import { handleRetrieveWebinar } from "../../../../../redux/specialist-slices/webinar.slice";
import TabPanel from "../../../../../components/common/TabPanel";
import { Fragment, useEffect, useRef, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import BasicDetail from "./basicDetail";
import Resources from "./resources";
import Schedule from "./schedule";
import Preview from "./preview";
import Format from "./format";

function SingleWebinar() {
  let formRef = useRef();
  const dispatch = useDispatch();
  const { id: webinarId } = useParams();
  const [data, setData] = useState(false);
  const [value, setValue] = useState("basics");
  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  // Handle retrieve single webinar
  const handleRetrieve = async () => {
    const { webinar } =
      (await dispatch(handleRetrieveWebinar(webinarId)).unwrap()) || {};
    if (webinar) {
      formRef.current = webinar;
      setData(true);
    }
  };

  useEffect(() => {
    handleRetrieve();
    // eslint-disable-next-line
  }, []);

  return (
    data && (
      <Fragment>
        <Tabs
          value={value}
          variant="scrollable"
          onChange={handleChange}
          sx={{ button: { fontFamily: "Poppins" } }}
        >
          <Tab label="Basics" value="basics" disabled />
          <Tab label="Schedule" value="schedule" disabled />
          <Tab label="Format & Access" value="format" disabled />
          <Tab label="Resources" value="resources" disabled />
          <Tab label="Preview & Submit" value="submission" disabled />
        </Tabs>

        <Box sx={{ pt: 3 }}>
          <TabPanel
            index={value}
            value="basics"
            children={
              <BasicDetail setValue={setValue} data={formRef.current} />
            }
          />
          <TabPanel
            index={value}
            value="schedule"
            children={<Schedule setValue={setValue} data={formRef.current} />}
          />
          <TabPanel
            index={value}
            value="format"
            children={<Format setValue={setValue} data={formRef.current} />}
          />
          <TabPanel
            index={value}
            value="resources"
            children={<Resources setValue={setValue} data={formRef.current} />}
          />
          <TabPanel
            index={value}
            value="submission"
            children={<Preview setValue={setValue} data={formRef.current} />}
          />
        </Box>
      </Fragment>
    )
  );
}

export default SingleWebinar;
